import { useMemo } from 'react'
import {
	generatePath,
	Navigate,
	Outlet,
	useLocation,
	useOutletContext
} from 'react-router'
import { qaStepIdToStepSlug } from '@/features/photoset/hooks/use-redirect-qa-photoset'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { qaStepsFlow } from '@/features/photoset/utils'
import { routes } from '@/routes'

export const Photoset2LaRoute = () => {
	const outletContext = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const { data: photoset, isLoading } = useGetPhotoset(
		{ id: outletContext.urlParams.id },
		{ staleTime: Number.POSITIVE_INFINITY }
	)
	const location = useLocation()
	const currentUrlStep = location.pathname.split('/').at(-1)

	const is2LaStepEnabled = useMemo(() => {
		if (!photoset?.qa_step_id) {
			return false
		}

		const qaStepKey = photoset.qa_step_id
			? qaStepIdToStepSlug?.[
					photoset.qa_step_id as keyof typeof qaStepIdToStepSlug
				]
			: null
		const urlStepFlowIndex = currentUrlStep
			? qaStepsFlow.indexOf(currentUrlStep)
			: -1
		const qaStepFlowIndex = qaStepKey ? qaStepsFlow.indexOf(qaStepKey) : -1

		return qaStepFlowIndex > urlStepFlowIndex
	}, [photoset, currentUrlStep])

	return is2LaStepEnabled || isLoading ? (
		<Outlet context={outletContext} />
	) : (
		<Navigate
			to={generatePath(routes.PHOTOSET_UNAVAILABLE_2LA.path, {
				id: photoset?.id ? String(photoset.id) : null
			})}
		/>
	)
}
